import { Grid } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React, { FC } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';

import { useBasket } from '../../../hooks/useBasket';
import { useUser } from '../../../hooks/useUser';
import { ICheckout } from '../../../store/basket/basket.interface';
import Basket from '../../../ui/basket/Basket';
import BasketEmpty from '../../../ui/basket/BasketEmpty/BasketEmpty';
import { setStoreLocal } from '../../../utils/local-storage';
import Meta from '../../../utils/meta/Meta';
import { BasketItems } from '../../Basket';

import styles from './Checkout.module.sass';
import CheckoutYourOrder from './CheckoutYourOrder/CheckoutYourOrder';
import ContactInformation from './ContactInformation/ContactInformation';
import NotAuthFields from './ContactInformation/NotAuthFields/NotAuthFields';
import MethodReceiving from './MethodReceiving/MethodReceiving';
import PaymentMethod from './PaymentMethod/PaymentMethod';
import { useCheckout } from './useCheckout';

const Checkout: FC = () => {
  const { checkout, otherValue, order_quantity } = useBasket();
  const { actions, checkoutData } = useCheckout();
  const { loggedIn } = useUser();
  const form = useForm<ICheckout>({
    mode: 'onChange',
    defaultValues: checkout,
  });

  const onSubmit: SubmitHandler<ICheckout> = async (data) => {
    // форматировать телефон на валидный формат
    /*    console.log(data);*/
    await actions.handleConfirm(data);
    setStoreLocal('checkout_data', data);
  };
  return (
    <Meta title="Корзина">
      <section className={styles.checkout}>
        <h1 className={styles.title}>Оформление заказа</h1>

        {order_quantity ? (
          <>
            <FormProvider {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className={styles.block}>
                  <Grid container xs={12} sm={12} md={12} lg={8}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      {!loggedIn && (
                        <Grid
                          container
                          columns={{ xs: 12, sm: 12, md: 12, lg: 10 }}
                          display="flex"
                          justifyContent="center"
                        >
                          <Grid
                            item
                            xs={11}
                            sm={11}
                            md={11}
                            lg={11}
                            justifyContent="center"
                          >
                            <NotAuthFields />{' '}
                          </Grid>
                        </Grid>
                      )}
                      {loggedIn && (
                        <Grid
                          container
                          columns={{ xs: 12, sm: 12, md: 12, lg: 10 }}
                          display="flex"
                          justifyContent="center"
                        >
                          <Grid
                            item
                            xs={11}
                            sm={11}
                            md={11}
                            lg={11}
                            justifyContent="center"
                          >
                            <ContactInformation />
                          </Grid>
                        </Grid>
                      )}
                      <Grid
                        container
                        columnSpacing={4}
                        display="flex"
                        justifyContent="center"
                      >
                        {loggedIn && (
                          <>
                            <Grid
                              item
                              xs={11}
                              sm={11}
                              md={11}
                              lg={6}
                              display="flex"
                              justifyContent="center"
                            >
                              <MethodReceiving />
                            </Grid>
                            <Grid
                              item
                              xs={11}
                              sm={11}
                              md={11}
                              lg={6}
                              display="flex"
                              justifyContent="center"
                            >
                              <PaymentMethod />
                            </Grid>
                          </>
                        )}
                        <Grid
                          item
                          xs={11}
                          sm={11}
                          md={11}
                          lg={12}
                          justifyContent="center"
                        >
                          <Basket />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container xs={12} sm={12} md={12} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid
                        container
                        columns={{ xs: 12, sm: 12, md: 12, lg: 10 }}
                        display="flex"
                        justifyContent="center"
                      >
                        <Grid
                          item
                          xs={11}
                          sm={11}
                          md={11}
                          lg={11}
                          justifyContent="center"
                        >
                          <CheckoutYourOrder />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </FormProvider>

            {checkoutData.loading && (
              <Backdrop className={styles.loading} open={checkoutData.loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
          </>
        ) : (
          <BasketEmpty />
        )}
      </section>
    </Meta>
  );
};

export default Checkout;
